export const AUTH_CODE_ERROR = "Two-factor code verification failed. Please try again."

export const STEP_QR = "qr"
export const STEP_RECOVERY = "recovery"
